import { useSortBy } from './useSortBy';
import FacetService from '@srcDS/js/patterns/organisms/Product/ProductListing/FacetService';
import Button from '../../atoms/button';
import clsx from 'clsx';
import { convertTextToId } from '@srcDS/js/utils/convertTextToId';
import { useFilter } from '@srcDS/tastic/pages/category/hooks/useFilter';
import { RadioButton } from '../../atoms/radio/RadioButton';
import { RadioGroup } from '../../atoms/radio/RadioGroup';
import styles from './Filter.module.scss';

interface SortValue {
  name: string;
  value: string;
}

interface UseSortByReturn {
  sortValues: SortValue[];
}

interface UseFilterReturn {
  handleSortChange: (sort: string) => void;
}

interface FilterDisplayValues {
  sortShown?: boolean;
  filterShown?: boolean;
}

interface SortProps {
  sortState: string;
  setFilterDisplayValues: React.Dispatch<React.SetStateAction<FilterDisplayValues>>;
  showTitle?: boolean;
  showCloseButton?: boolean;
  title?: string;
  onClose?: () => void;
}

export const Sort: React.FC<SortProps> = ({
  sortState,
  setFilterDisplayValues,
  showTitle = true,
  showCloseButton = true,
  title = 'Sort',
  onClose,
}) => {
  const { sortValues }: UseSortByReturn = useSortBy();
  const { handleSortChange }: UseFilterReturn = useFilter();
  const isSortEqual = (a: string, b: string): boolean => FacetService.isSortEqual(a, b);

  const renderSortBy = (): JSX.Element[] =>
    sortValues.map((sort: SortValue, termIndex: number) => (
      <div key={`sortBy-option-${termIndex}`} className={styles.sortList}>
        <div className={styles.filterItems}>
          <RadioButton
            // @ts-ignore
            variant="inverse"
            defaultChecked={isSortEqual(sort.value, sortState)}
            label={sort.name}
            customLabelStyle={styles.filterItemsLabel}
            value={sort.value}
            className={clsx(styles.checkbox)}
            customClasses={{
              inputBlock: styles.customInputBlock,
            }}
            dataAttributes={{
              'data-filter-attribute': convertTextToId(sort?.name),
            }}
          />
        </div>
      </div>
    ));

  const closeSort = () => {
    setFilterDisplayValues((values: FilterDisplayValues) => ({
      ...values,
      sortShown: false,
    }));
    onClose?.();
  };

  return (
    <div className={showTitle && styles.sortContainer}>
      {showTitle && <h2 className={styles.sortTitle}>{title}</h2>}
      {/* @ts-ignore */}
      <RadioGroup
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          console.log(e.target.value);
          const sort = e.target.value;
          handleSortChange(sort);
          closeSort();
        }}
      >
        {renderSortBy()}
      </RadioGroup>
      {showCloseButton && (
        /*@ts-ignore*/
        <Button
          variant="primaryOutlined"
          customClasses={{
            button: styles.sortButton,
          }}
          onClick={closeSort}
        >
          Close
        </Button>
      )}
    </div>
  );
};
